import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

type Props = {
  name: IconProp;
  size?: SizeProp;
  className?: string;
  label?: string | undefined;
  style?: React.CSSProperties;
};

function AwesomeIcon({
  name,
  size = "lg",
  className = "",
  label = undefined,
  style = {},
}: Props) {
  return (
    <FontAwesomeIcon
      icon={name}
      size={size}
      className={className}
      aria-hidden="true"
      aria-label={label}
      style={style}
    />
  );
}

export default AwesomeIcon;
